<template>
	<span aria-hidden="true">
		<img src="../../img/icons/refresh.svg" alt=""/>
	</span>
</template>

<script>
export default {}
</script>

